"use strict";

/**
 *
 * FontFaceObserver is used to efficiently load web fonts. @font-face
 * rules must be setup in this site's stylesheets for this to work
 * properly.
 *
 * @since 1.0.0
 *
 * @see https://github.com/bramstein/fontfaceobserver
 * @see https://github.com/zachleat/web-font-loading-recipes/blob/master/fout-with-class.html
 *
 */
const init = function() {
  const RobotoMediumItalic = new FontFaceObserver("Roboto", {
    weight: 500,
    style: "italic"
  });
  const RobotoMedium = new FontFaceObserver("Roboto", {
    weight: 500,
    style: "normal"
  });
  const RobotoBold = new FontFaceObserver("Roboto", {
    weight: 700,
    style: "normal"
  });
  const RobotoBlack = new FontFaceObserver("Roboto", {
    weight: 900,
    style: "normal"
  });
  // promise polyfill is included in FontFaceObserver unless
  // using the standalone version
  Promise.all([
    RobotoMediumItalic.load(),
    RobotoMedium.load(),
    RobotoBold.load(),
    RobotoBlack.load()
  ]).then(function() {
    // Optimization for Repeat Views
    // @see https://www.zachleat.com/web/comprehensive-webfonts/#fout-class
    sessionStorage.fontsLoadedFoutWithClassPolyfill = true;

    if (!document.documentElement.classList.contains("fonts-loaded")) {
      document.documentElement.className += " fonts-loaded";
    }
  });
};

const api = {
  init: init
};

export default api;
